"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Capitalizes the first letter of a given string.
 *
 * @see {@link https://gitlab.fitness-plus.net/developers/utils#capitalizestring}
 */
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.default = capitalize;
